export default "__VITE_ASSET__CsBiegly__"